// Do not edit.
import { ShaderStore } from "core/Engines/shaderStore";

const name = "aerialPerspectivePixelShader";
const shader = `#define RENDER_CAMERA_VOLUME
precision highp float;
#include<__decl__atmosphereFragment>
uniform sampler2D transmittanceLut;
uniform sampler2D multiScatteringLut;
#include<helperFunctions>
#include<atmosphereFunctions>
varying vec3 positionOnNearPlane;
uniform float layerIdx;void main() {gl_FragColor=renderCameraVolume(
positionOnNearPlane,
layerIdx,
transmittanceLut,
multiScatteringLut
);}`;
// Sideeffect
if (!ShaderStore.ShadersStore[name]) {
    ShaderStore.ShadersStore[name] = shader;
}
ShaderStore._PendingIncludesLoaders.push(() => Promise.all([
    import("../Shaders/ShadersInclude/atmosphereFragmentDeclaration"),
    import("../Shaders/ShadersInclude/atmosphereUboDeclaration"),
    import("core/Shaders/ShadersInclude/helperFunctions"),
    import("../Shaders/ShadersInclude/atmosphereFunctions")
]));
/** @internal */
export const aerialPerspectivePixelShader = { name, shader };
